import en from "./en-us"
import zh from "./zh-cn"
import tw from "./zh-TW"
import jp from "./ja-JP"
import fr from './fr-FR'
import ko from './ko-KR'

import Vue from "vue"
import VueI18n from "vue-i18n"
import cookie from "../utils/cookie"

Vue.use(VueI18n);

const messages = {
  "zh-CN": zh,
  "en-US": en,
  "zh-TW": tw,
  "zh-HK": tw,
  "ja-JP": jp,
  "fr-FR": fr,
  "ko-KR": ko
};
const dateFormate = {
  "zh-CN": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  "en-US": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
};
const defaultLanguage = "en-US";
var localLang = cookie.get("lang");
let language = localLang || defaultLanguage;
var lang;
switch (language){
  case "zh-CN":
    lang = "zh-CN";
    break;
  case "en-US":
    lang = "en-US";
    break;
  case "zh-HK":
  case "zh-TW":
    lang = "zh-TW";
    break;
  case "ja-JP":
    lang = "ja-JP";
    break;
  case "fr-FR":
    lang = "fr-FR"
    break;
  case "ko-KR":
    lang = "ko-KR"
    break;
  default: lang = "en-US";
}

cookie.set("lang", lang);

const i18n = new VueI18n({
  locale: language,
  messages: messages,
  dateTimeFormats: dateFormate,//日期格式化$d
  fallbackLocale: "en-US",
  silentTranslationWarn: true
});

export default i18n;




// WEBPACK FOOTER //
// ./src/lang/index.js